App.directive('routeLoadingIndicator', routeLoadingIndicator);

routeLoadingIndicator.$inject = ['$rootScope'];

function routeLoadingIndicator($rootScope) {
    return {
        restrict: 'E',
        templateUrl: 'common/views/routeLoadingView.html',
        link: function(scope) {
            scope.isRouteLoading = false;

            $rootScope.$on('$routeChangeStart', function() {
                $('html,body').scrollTop(0);

                scope.isRouteLoading = true;
            });

            $rootScope.$on('$routeChangeSuccess', function() {
                scope.isRouteLoading = false;
            });
        }
    };
}